import RepositoryFactory from "../../admin/apis/index";
const agent = RepositoryFactory.AgentRouting;
export default {
  GetRM({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("createagent called");
        const { data } = await agent.GetRM(payload);
        console.log(data, "datadatadata");
        commit("GET_RM", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getRmList({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("createagent called");
        const { data } = await agent.getRmList(payload);
        console.log(data, "datadatadata");
        commit("GET_RM_LIST", data.data[0]);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  AssignChat({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.AssignChat(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  RMContact({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.RMContact(payload);
        commit("GET_RM_CONTACT", data.data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },
  GetAssignRmName({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.GetAssignRmName(payload);
        commit("GET_ASSIGN_RM_NAME", data.data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },
  GetAssigned({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.GEtAssigned(payload);
        commit("GET_ASSIGN", data.data[0]);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },
  checkChatStatus({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.checkChatStatus(payload);
        commit("CHECK_STATUS", data.data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },
  updateChatStatus({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.updateChatStatus(payload);
        // commit("CHECK_STATUS", data.data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },
  assignStatus({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.assignStatus(payload);
        commit("CHECK_ASSIGN_STATUS", data.data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },
  UpdateChatExp({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.UpdateChatExp(payload);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },
  GetAllassignchat({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.GetAllassignchat(payload);
        commit("COMMIT_ALL_ASSIGN_USER", data.data);

        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },
  OptIn({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/optin/getAllOptinUser")
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  AverageClosure({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.AverageClosure(payload);
        // commit("COMMIT_ALL_ASSIGN_USER", data.data);

        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },

  statusFilter({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await agent.statusFilter(payload);
        commit("SET_FiILTER_STATUS", data.data);

        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },
};
